import {Alert, Button, EmptyStatus} from 'platform/components';
import {Box, HStack, VStack, Show} from 'platform/foundation';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

interface BusinessCaseTradeInEmptyProps {
  isReadOnly: boolean;
  linkExistingLabelKey: string;
  createNewLabelKey: string;
  isInvoiceBlocked: boolean;
  onLinkExisting: () => void;
  onCreateNew: () => void;
}

export function BusinessCaseTradeInEmpty(props: BusinessCaseTradeInEmptyProps) {
  // A final invoice was already issued: the trade-in can no longer be changed, so we hide the
  // empty state and actions and surface only the blocking banner.
  if (props.isInvoiceBlocked) {
    return (
      <Box padding={11}>
        <Alert
          type="banner"
          variant="info"
          title={i18n.t('page.businessCase.tradeIn.invoiceBlockedBanner')}
          data-testid={testIds.businessCase.detail('tradeInInvoiceBlocked')}
        />
      </Box>
    );
  }

  return (
    <Box padding={11}>
      <VStack spacing={4} align="center">
        <EmptyStatus
          headline={i18n.t('page.businessCase.tradeIn.emptyTitle')}
          subheadline={
            !props.isReadOnly ? i18n.t('page.businessCase.tradeIn.emptyDescription') : undefined
          }
          data-testid={testIds.businessCase.detail('tradeInEmpty')}
        />
        <Show when={!props.isReadOnly}>
          <HStack spacing={2}>
            <Button
              variant="primary"
              title={i18n.t(props.linkExistingLabelKey)}
              onClick={props.onLinkExisting}
              data-testid={testIds.businessCase.detail('tradeInLinkExisting')}
            />
            <Button
              variant="secondary"
              title={i18n.t(props.createNewLabelKey)}
              onClick={props.onCreateNew}
              data-testid={testIds.businessCase.detail('tradeInCreateNew')}
            />
          </HStack>
        </Show>
      </VStack>
    </Box>
  );
}
